import {RepositoryFactory} from '../../api/RepositoryFactory';

export default {
    actions: {
        GET_TEAMS: async (context, payload) => {
            await RepositoryFactory.get('teams').get(payload).then((res) => {
                context.commit('SET_TEAMS', res.data.teams)
            });
        },

        ADD_ATTACHMENT: async (context, payload) => {
            await RepositoryFactory.get('teams').storeAttachment(payload).then((res) => {
                context.commit('ADD_ATTACHMENT', res.data.attachment)
            });
        }
    },

    mutations: {
        SET_TEAMS: (state, payload) => {
            state.teams = payload;
        },

        ADD_ATTACHMENT: (state, payload) => {
            state.team_attachments.unshift(payload);
        }
    },

    state: {
        teams: [],
        team_attachments: []
    },

    getters: {
        TEAMS: state => {
            return state.teams;
        },

        TEAM_ATTACHMENTS: state => {
            return state.team_attachments;
        }
    }
}